import { render } from "./add-worker.vue?vue&type=template&id=22d6ddae&scoped=true&ts=true"
import script from "./add-worker.vue?vue&type=script&lang=ts"
export * from "./add-worker.vue?vue&type=script&lang=ts"

import "./add-worker.vue?vue&type=style&index=0&id=22d6ddae&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d6ddae"]])

export default __exports__